"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgorithmLevelsConfiguration = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Engagement_1 = require("Common/Engagement");
var AlgorithmEditor_1 = require("./AlgorithmEditor");
var styles = __importStar(require("./AlgorithmEditModal.css"));
var AlgorithmLevelsConfiguration = function (_a) {
    var algorithm = _a.algorithm, onChange = _a.onChange;
    var commonProps = { algorithm: algorithm, onChange: onChange };
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.levelsConfigurationWrapper, gap: "xs" },
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", secondary: true, strong: true }, "Define engagement levels"),
        react_1.default.createElement(AlgorithmAccordion, __assign({ engagementLevel: "highly engaged" }, commonProps)),
        react_1.default.createElement(AlgorithmAccordion, __assign({ engagementLevel: "engaged" }, commonProps)),
        react_1.default.createElement(LevelAccordion, { engagementLevel: "neutral" },
            react_1.default.createElement(NeutralLevelContent, null)),
        react_1.default.createElement(AlgorithmAccordion, __assign({ engagementLevel: "disengaged" }, commonProps)),
        react_1.default.createElement(AlgorithmAccordion, __assign({ engagementLevel: "highly disengaged" }, commonProps))));
};
exports.AlgorithmLevelsConfiguration = AlgorithmLevelsConfiguration;
var increasingEngagementInfoLinks = [
    {
        display: "Increasing engagement Pt. 1",
        link: "unknown",
        thumbnailImage: "Assets/Images/increasing-engagement-1.png",
    },
    {
        display: "Increasing engagement Pt. 2",
        link: "unknown",
        thumbnailImage: "Assets/Images/increasing-engagement-2.png",
    },
];
var NeutralLevelContent = function () { return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", direction: "vertical" },
    react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "The algorithm will determine buyer engagement as neutral, if none of the rules in the other levels (high engagement, low engagement, low disengagement, high disengagement) evaluate to true."),
    react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/824-engagement-algorithm" }, "Learn about engagement algorithms"))); };
var LevelAccordion = function (_a) {
    var engagementLevel = _a.engagementLevel, toggleValue = _a.toggleValue, onToggle = _a.onToggle, children = _a.children;
    var _b = __read(react_1.default.useState(false), 2), expanded = _b[0], setExpanded = _b[1];
    var toggleLabel = "".concat(toggleValue ? "Disable" : "Enable", " engagement level");
    var isDisabled = toggleValue === false;
    var engagementLevelDisplayName = (0, Engagement_1.getEngagementLevelDisplayName)(engagementLevel);
    function onToggleChange(isActive) {
        onToggle(isActive);
        setExpanded(isActive);
    }
    function toggleExpanded() {
        setExpanded(!expanded);
    }
    return (react_1.default.createElement("div", { className: styles.accordionCardWrapper },
        react_1.default.createElement(kaleidoscope_1.ButtonCard, { className: styles.accordionButtonCard({ isDisabled: isDisabled }), onClick: toggleExpanded }),
        react_1.default.createElement("div", { className: styles.accordionContentWrapper({ expanded: expanded }) },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween" },
                react_1.default.createElement(kaleidoscope_1.Stack, { className: "".concat(isDisabled ? styles.desaturatedAccordionHeading : ""), direction: "horizontal", align: "center", justify: "start", gap: "l" },
                    react_1.default.createElement(Engagement_1.EngagementIcon, { engagementLevel: engagementLevel, size: icons_1.IconSize.Large }),
                    react_1.default.createElement(kaleidoscope_1.Heading, { className: styles.accordionHeaderText, level: "4", strong: true, secondary: isDisabled }, engagementLevelDisplayName)),
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "end", gap: "xs", style: { pointerEvents: "auto" } },
                    onToggle && (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.accordionToggleContainer, direction: "horizontal", align: "center", justify: "center" },
                        react_1.default.createElement(kaleidoscope_1.Tooltip, { content: toggleLabel, autoStack: true, wrapTarget: true },
                            react_1.default.createElement(kaleidoscope_1.Toggle, { labelHidden: true, label: toggleLabel, value: toggleValue, onChange: onToggleChange })))),
                    react_1.default.createElement(kaleidoscope_1.IconButton, { size: kaleidoscope_1.ButtonSize.Medium, icon: expanded ? react_1.default.createElement(icons_1.ChevronDown, null) : react_1.default.createElement(icons_1.ChevronRight, null), onClick: toggleExpanded }))),
            react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: expanded }, function (_a) {
                var expandableElementRef = _a.expandableElementRef;
                return (react_1.default.createElement(kaleidoscope_1.Stack, { ref: expandableElementRef, paddingTop: "xs" }, children));
            }))));
};
var levelsMapping = {
    "highly engaged": "highly_engaged",
    engaged: "engaged",
    disengaged: "disengaged",
    "highly disengaged": "highly_disengaged",
};
var AlgorithmAccordion = function (_a) {
    var engagementLevel = _a.engagementLevel, algorithm = _a.algorithm, onChange = _a.onChange;
    var levelName = levelsMapping[engagementLevel];
    var rootNode = algorithm.levelsConfiguration[levelName];
    function onToggle() {
        var updatedNode = !!rootNode ? null : { kind: "AND", values: [] };
        updateNode(updatedNode);
    }
    function updateNode(updatedNode) {
        var _a;
        onChange(__assign(__assign({}, algorithm), { levelsConfiguration: __assign(__assign({}, algorithm.levelsConfiguration), (_a = {}, _a[levelName] = updatedNode, _a)) }));
    }
    return (react_1.default.createElement(LevelAccordion, { engagementLevel: engagementLevel, toggleValue: !!rootNode, onToggle: onToggle },
        react_1.default.createElement(AlgorithmEditor_1.AlgorithmEditor, { engagementLevel: engagementLevel, rootNode: rootNode, onChange: updateNode })));
};
